// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDivision} from '../../../product/shared/repositories';

export const updateDivisionParams = (isSapUp = true) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const division = await getDivision(isSapUp);

            dispatch({
                division,
                type: actions.UPDATE_DIVISION_SUCCESS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/dealer-search/action-creators/update-division-params.js